// AboutMetaData.js
// AboutMetaData.js
import React from 'react';
import { Helmet } from 'react-helmet-async';  // Add this import


export const AboutMetaData = () => {
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "AboutPage",
          "@id": "https://www.meatbuddy.in/about/#webpage",
          "url": "https://www.meatbuddy.in/about",
          "name": "About Meat Buddy - Premium Meat Delivery Service",
          "description": "Learn about Meat Buddy's commitment to delivering premium quality fresh meat in Bengaluru. Farm-to-fork quality, same-day delivery.",
          "isPartOf": { "@id": "https://www.meatbuddy.in/#website" }
        },
        {
          "@type": "Organization",
          "name": "Vistara Farms Private Limited",
          "foundingDate": "2025-03",
          "description": "Premium meat delivery service established in 2025, serving Bengaluru with fresh, high-quality meat products.",
          "slogan": "Fresh Meat Delivered",
          "areaServed": "Bengaluru"
        }
      ]
    };
  
    return (
      <Helmet>
        <title>About Us - Meat Buddy | Premium Meat Delivery Service</title>
        <meta name="description" content="Meat Buddy, a venture of Vistara Farms Private Limited, delivers premium quality fresh meat in Bengaluru. Learn about our commitment to quality, hygiene, and customer satisfaction." />
        <meta name="keywords" content="about meat buddy, meat delivery service bangalore, premium meat supplier, fresh meat delivery" />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
    );
  };
  